/**
 * IIFE entry — bundles everything into a single global `Nexor` for script-tag
 * embeds. Each method of the singleton is re-exported so that the IIFE format
 * exposes them directly on the global (e.g. `Nexor.init`, `Nexor.initChat`)
 * without consumers having to dig into `.default`.
 *
 *   <script src="https://unpkg.com/@getnexor/sdk/dist/nexor.iife.js"></script>
 *   <script>
 *     Nexor.init({ apiKey: "nx_live_…" });
 *     Nexor.initChat({ workflowId: "…" });
 *   </script>
 */
import { nexor } from "./index";

export {
  NexorClient,
  NexorError,
  NexorAPIError,
  NexorAuthError,
  NexorValidationError,
  NexorNetworkError,
  createClient,
} from "./index";

export const init = nexor.init;
export const isInitialized = nexor.isInitialized;
export const reset = nexor.reset;
export const initChat = nexor.initChat;

// Lead methods
export const createLead = nexor.createLead;
export const createLeadsBulk = nexor.createLeadsBulk;
export const updateLead = nexor.updateLead;
export const getLead = nexor.getLead;
export const getLeadHistory = nexor.getLeadHistory;
export const isLeadPaused = nexor.isLeadPaused;
export const stopAutomation = nexor.stopAutomation;
export const resumeAutomation = nexor.resumeAutomation;
export const syncLeadTags = nexor.syncLeadTags;
export const listLeadMeetings = nexor.listLeadMeetings;

// Workflows / Campaigns / Templates
export const listWorkflows = nexor.listWorkflows;
export const listCampaigns = nexor.listCampaigns;
export const listTemplates = nexor.listTemplates;

// Messages
export const sendMessage = nexor.sendMessage;

// Meetings
export const createMeeting = nexor.createMeeting;
export const createMeetingNotes = nexor.createMeetingNotes;
